import CompanyForm from '@/components/companies/forms/CompanyForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useNavigate } from 'react-router-dom';

export default function CompanyAddPage() {
  const navigate = useNavigate();

  return (
    <DefaultLayout
      header="Add New Company"
      breadcrumb={[
        { label: 'Companies', href: ROUTES.COMPANIES },
        { label: 'Add Company', isActive: true },
      ]}>
      <CompanyForm
        onSuccess={(uuid: string) => navigate(`${ROUTES.COMPANIES}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
